// console.log('base js')

var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
    case 'amount_with_apostrophe_separator':
      value = formatWithDelimiters(cents, 0, '\'', '.');
    break;
  }

  return formatString.replace(placeholderRegex, value);
};


// Product quantity picker
class ProductQuantityPicker extends HTMLElement{
    constructor(){
        super();

        var productQualityPickerSpan = this.querySelectorAll('span');

        for(let qualityCounter of productQualityPickerSpan){
            qualityCounter.addEventListener('click', (event) => this.onClick(event, qualityCounter))
            qualityCounter.addEventListener('keypress', (event) => this.onClick(event, qualityCounter))
            
        }

    }

    onClick = (event, qualityCounter) => {

        var isKeypressValid = event.type == 'keypress' && event.key === 'Enter'

        if( !(event.type == 'click' || isKeypressValid) ){
            return false;
        }

        var qtyInput = this.querySelector('input');
        var qtyInputValue = qtyInput.value //qtyInput.getAttribute('value');
        var qtyInputMin = parseInt(qtyInput.getAttribute('min'));
        var qtyInputMax = parseInt(qtyInput.getAttribute('max'));

        if( qualityCounter.classList.contains('qty-minus') ){
            if( isNaN(qtyInputMin) || qtyInputMin < qtyInputValue ){
                qtyInputValue--
            }
        }
        if( qualityCounter.classList.contains('qty-plus') ){
            if( isNaN(qtyInputMax) || qtyInputMax > qtyInputValue ){
                qtyInputValue++
            }else{
                const productQtyPicker = qualityCounter.closest('product-quantity-picker');
                const productQty = productQtyPicker.querySelector('.product-quantity-picker-input');
                const textQtyError = productQty.dataset.textQtyError;

                const errorParagraph = productQtyPicker.nextElementSibling;
                const isErrorExist = errorParagraph.classList.contains('error')
                //const newErrorHTML = '<p class="error">' + textQtyError.replace('%qty', productQty.getAttribute('max') + ' ' + productTitle + ' - ' + productQty.dataset.textVariant) + '</p>';
                const newErrorHTML = '<p class="error">' + textQtyError.replace('%qty', productQty.getAttribute('max')) + '</p>';
                errorParagraph.innerHTML = newErrorHTML;
                // if( isErrorExist ){
                //     errorParagraph.innerHTML = newErrorHTML;
                // }
                // else{
                //     productQtyPicker.insertAdjacentHTML('afterend', newErrorHTML)
                // }

                return
            }
        }

        qtyInput.value = qtyInputValue;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));

        let bulkQty = document.querySelector('[data-bulk-qty]');
        if(bulkQty){
            let bulkQtyValue = Number(bulkQty.dataset.bulkQty);
            let bulkQtyRegPrice = bulkQty.dataset.price;
            let bulkQtyBulkPrice = bulkQty.dataset.bulkPrice;
            let qtyBeforeDiscount = document.querySelector('[data-qty-before-discount]');
            let qtyAfterDiscount = document.querySelector('[data-qty-after-discount]');
            if(qtyInputValue < bulkQtyValue){
                bulkQty.innerText = bulkQtyRegPrice;
                if(qtyAfterDiscount){
                    qtyAfterDiscount.style.display = 'none';
                }
                if(qtyBeforeDiscount){
                    qtyBeforeDiscount.style.display = 'block';            
                    qtyBeforeDiscount.querySelector('span').innerText = (3 - qtyInputValue);
                }
            }else{
                bulkQty.innerText = bulkQtyBulkPrice;
                if(qtyBeforeDiscount){
                    qtyBeforeDiscount.style.display = 'none';
                }
                if(qtyAfterDiscount){
                    qtyAfterDiscount.style.display = 'block';
                }
            }
        }
        // console.log("quantity", qtyInput.getAttribute('value'), qtyInputValue)
    }
}

customElements.define( 'product-quantity-picker', ProductQuantityPicker );


// Search Dropdown
class SearchDropdown extends HTMLElement {
    constructor() {
        super();

        this.dropdownToggle = this.querySelector('.search-dropdown-toggle');
        this.dropdownContents = this.querySelector('.search-dropdown-container');
        this.searchField = this.querySelector('input[type="search"]');
        this.dropdownClose = this.querySelector('.search-dropdown-close');
        // console.log("search dropdown called");

        this.dropdownToggle.addEventListener('click', (e) => {
            e.preventDefault();

            this.onClick(e)
        });

        this.dropdownClose.addEventListener('click', () => this.close())
        // this.dropdownToggle.addEventListener('click', () => { this.searchField.focus() });

        document.addEventListener('click', (event) => {
            if (event.target !== this && !this.contains(event.target)) {
                this.close()
            }
        })
    }

    onClick(e) {
        // e.stopPropagation();

        // console.log("dropdown", e.target)

        if( !this.classList.contains('active') ){
            this.open();

            setTimeout(() => {
                this.searchField.focus()
            }, 100);
        }
        else{
            this.close();
        }
    }

    open() {
        this.classList.add('active');
    }

    close() {
        this.classList.remove('active');
    }
}

customElements.define('search-dropdown', SearchDropdown);


// Carousel
const carouselElements = document.querySelectorAll('.has-carousel');

carouselElements.forEach(carouselElement => {
    // if (carouselElement.classList.contains('splide') && !carouselElement.classList.contains('product-gallery-images')) {
        // console.log("carousel element", carouselElement);
        let carouselOptions = null;
    
        if (carouselElement.dataset.options) {
            carouselOptions = JSON.parse(carouselElement.dataset.options);
        } else {
            carouselOptions = {};
        }

        carouselOptions['classes'] = {
            // Add classes for arrows.
            arrows: 'splide__arrows',
            arrow : 'splide__arrow',
            prev  : 'splide__arrow--prev',
            next  : 'splide__arrow--next',
    
            // // Add classes for pagination.
            // pagination: 'splide__pagination your-class-pagination', // container
            // page      : 'splide__pagination__page your-class-page', // each button
        };

        carouselOptions.pauseOnHover = false;
        if(carouselOptions.destroyOnDeskctop){
            carouselOptions.breakpoints = {
                768: {
                    destroy: true,
                }
            }
        }
        
        const splide = new Splide(carouselElement, carouselOptions);
        var pageNumber = carouselElement.querySelector('.splide__page-number');
        const desktopQuery = window.matchMedia('(min-width: 1200px)');

        function setHeightToFirstSlide() {
            if (!desktopQuery.matches) {
            // Reset to auto height on smaller screens
            splide.root.style.height = '';
            splide.Components.Elements.track.style.height = '';
            return;
            }

            const firstSlide = splide.Components.Elements.slides[0];
            if (!firstSlide) return;

            const slideHeight = firstSlide.offsetHeight;
            if (slideHeight > 0) {
            splide.root.style.height = slideHeight + 'px';
            splide.Components.Elements.track.style.height = slideHeight + 'px';
            }
        }

        splide.on('mounted resize', setHeightToFirstSlide);

        if(pageNumber){
            splide.on('ready', function (newIndex) {
                pageNumber.querySelector('.splide__page-number-bar-inner').classList.add('run');
            });
            splide.on('move', function (newIndex) {
                pageNumber.querySelector('.splide__page-number-current').textContent = '0' + (newIndex + 1);
                pageNumber.querySelector('.splide__page-number-bar-inner').classList.remove('run');
            });
            splide.on('moved', function (newIndex) {
                pageNumber.querySelector('.splide__page-number-current').textContent = '0' + (newIndex + 1);
                pageNumber.querySelector('.splide__page-number-bar-inner').classList.add('run');
            });
        }
        splide.mount();

        if (carouselElement.classList.contains('section-slideshow') && document.readyState !== 'complete') {
            const paginationButtons = carouselElement.querySelectorAll('.splide__pagination__page');

            paginationButtons.forEach(button => button.disabled = true);
            window.addEventListener('load', () => {
                paginationButtons.forEach(button => button.disabled = false);
            }, { once: true });
        }
    // }
});


// Popup modal
class PopupModal extends HTMLElement{
    constructor(){
        super();

        this.popupCloseButton = this.querySelector('.popup-modal__close');
        this.popupOverlay = this.querySelector('.popup-modal__overlay');


        this.popupCloseButton.addEventListener('click', () => {
            this.onClose();
        })

        this.popupOverlay.addEventListener('click', () => {
            this.onClose();
        })

        this.addEventListener('keydown', (event) => {
            if( !this.classList.contains('quickshop-modal') || event.defaultPrevented || document.querySelector('.pswp--open') ){
                return;
            }

            if( event.key === 'Escape' ){
                this.onClose();
                return;
            }

            if( !['ArrowLeft', 'ArrowRight'].includes(event.key) || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey || event.target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"]), [role="slider"], [role="combobox"], product-option-picker') ){
                return;
            }

            event.preventDefault();
            var direction = event.key === 'ArrowLeft' ? 'previous' : 'next';
            var button = this.querySelector(`.quickshop-navigation__${direction}`);
            if( button && !button.disabled && !event.repeat ){
                button.click();
            }
        })


        if( this.dataset.popupType == 'onload' ){
            this.handleOnLoadPopup();

            this.sectionPopupClose = this.querySelector('.section-popup-button-close');

            if( this.sectionPopupClose ){
                this.sectionPopupClose.addEventListener('click', (e) => {
                    e.preventDefault();
                    
                    this.onClose();
                })
            }
            
        }


    }

    onClose(){
        if( this.quickShopRequest ){
            this.quickShopRequest.abort();
            this.quickShopRequest = null;
        }

        var returnFocusElement = this.returnFocusElement;

        if( this.classList.contains('quickshop-modal') ){
            this.remove();
        }
        else{
            this.classList.add('inactive');
            this.classList.remove('quickview-modal');
            this.querySelector('.popup-modal__content').innerHTML = '';
        }

        if( returnFocusElement && returnFocusElement.isConnected ){
            returnFocusElement.focus();
        }
    }


    handleOnLoadPopup = () => {
        // console.log("its newsletter popup");

        this.style.display = null;

        var expireOn = parseInt(this.dataset.popupExpiry);
        var delay = this.dataset.popupDelay;
        var cookieName = this.dataset.popupCookieName;
        var frequency = 1;
        
        var visits = 0;
        if( Cookies.get(cookieName) ){
            visits = Cookies.get(cookieName);
        }
        visits++;

        Cookies.set(cookieName, visits, { expires: expireOn, path: '/' });

        if (Cookies.get(cookieName) > frequency) {

            this.onClose();
        }
        else {
            window.onload = setTimeout( () => {
                this.classList.remove('inactive');
            }, delay )
        }


    }
}

customElements.define('popup-modal', PopupModal)

// Quick Shop
function setQuickShopPage(popupModal, productQuickview){
    var source = productQuickview.closest('.products');
    var currentPage = productQuickview.dataset.quickShopPage;
    var buttons = source ? Array.from(source.querySelectorAll('.product-quickview[data-handle]')) : [productQuickview];

    popupModal.quickShopPage = {
        buttons: buttons.filter((button) => button.dataset.quickShopPage === currentPage),
        currentPage: parseInt(currentPage) || 1,
        totalPages: parseInt(productQuickview.dataset.quickShopPages) || 1,
        offset: parseInt(productQuickview.dataset.quickShopOffset) || 0,
        total: parseInt(productQuickview.dataset.quickShopTotal) || buttons.length,
        previousUrl: productQuickview.dataset.quickShopPreviousUrl || '',
        nextUrl: productQuickview.dataset.quickShopNextUrl || ''
    };
}

function updateQuickShopNavigation(popupModal, handle){
    var page = popupModal.quickShopPage;
    var buttons = page ? page.buttons : [];
    var currentIndex = buttons.findIndex((button) => button.dataset.handle === handle);
    var previousButton = popupModal.querySelector('.quickshop-navigation__previous');
    var nextButton = popupModal.querySelector('.quickshop-navigation__next');
    var position = popupModal.querySelector('.quickshop-navigation__position');
    var labels = popupModal.quickShopLabels;

    if( currentIndex < 0 ){
        previousButton.disabled = true;
        nextButton.disabled = true;
        position.textContent = '';
        return;
    }

    var previousProduct = buttons[currentIndex - 1];
    var nextProduct = buttons[currentIndex + 1];

    previousButton.disabled = !previousProduct && !page.previousUrl;
    previousButton.dataset.handle = previousProduct ? previousProduct.dataset.handle : '';
    previousButton.dataset.pageUrl = previousProduct ? '' : page.previousUrl;
    nextButton.disabled = !nextProduct && !page.nextUrl;
    nextButton.dataset.handle = nextProduct ? nextProduct.dataset.handle : '';
    nextButton.dataset.pageUrl = nextProduct ? '' : page.nextUrl;
    position.textContent = `${page.offset + currentIndex + 1} ${labels.of} ${page.total}`;
}

function getQuickShopModal(productQuickview){
    var popupModal = document.querySelector('body > .quickshop-modal');

    if( popupModal ){
        return popupModal;
    }

    var quickShopModalString = `<popup-modal class="popup-modal quickshop-modal" role="dialog" aria-modal="true" tabindex="-1">
        <div class="popup-modal__overlay"></div>
        <div class="popup-modal__inner">
            <nav class="quickshop-navigation">
                <button class="quickshop-navigation__button quickshop-navigation__previous" type="button" data-quick-shop-direction="previous"></button>
                <span class="quickshop-navigation__position" aria-live="polite"></span>
                <button class="quickshop-navigation__button quickshop-navigation__next" type="button" data-quick-shop-direction="next"></button>
            </nav>
            <div class="popup-modal__content"></div>
            <button class="popup-modal__close" type="button">
                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <line x1="1.11092" y1="0.610962" x2="8.88909" y2="8.38914" stroke="#171813" stroke-linecap="round"/>
                    <line x1="1.11096" y1="8.38915" x2="8.88914" y2="0.610971" stroke="#171813" stroke-linecap="round"/>
                </svg>
            </button>
        </div>
    </popup-modal>`;

    popupModal = new DOMParser().parseFromString(quickShopModalString, 'text/html').querySelector('popup-modal');
    popupModal.setAttribute('aria-label', productQuickview.textContent.trim());
    popupModal.querySelector('.quickshop-navigation').setAttribute('aria-label', productQuickview.textContent.trim());
    popupModal.querySelector('.popup-modal__close').setAttribute('aria-label', productQuickview.dataset.quickShopClose || 'Close');
    document.body.prepend(popupModal);

    return popupModal;
}

function setupQuickShopZoom(product){
    product.querySelectorAll('.product-gallery-images__image a').forEach((link) => {
        var image = link.querySelector('img');
        if( !image ) return;

        link.classList.add('quickshop-zoom');
        var zoomImage;
        var hovering = false;

        link.addEventListener('pointermove', (event) => {
            if( event.pointerType === 'touch' || !window.matchMedia('(hover: hover) and (pointer: fine)').matches ) return;

            hovering = true;
            if( !zoomImage ){
                zoomImage = image.cloneNode(false);
                zoomImage.removeAttribute('srcset');
                zoomImage.removeAttribute('sizes');
                zoomImage.removeAttribute('id');
                zoomImage.alt = '';
                zoomImage.setAttribute('aria-hidden', 'true');
                zoomImage.loading = 'eager';
                zoomImage.className = 'quickshop-zoom-image';
                zoomImage.addEventListener('load', () => zoomImage.classList.toggle('is-zoomed', hovering));
                var zoomUrl = new URL(link.href);
                zoomUrl.searchParams.set('width', Math.min(Number(link.dataset.pswpWidth) || 2400, 2400));
                zoomImage.src = zoomUrl.href;
                link.append(zoomImage);
            }

            var bounds = link.getBoundingClientRect();
            var x = Math.max(0, Math.min(100, (event.clientX - bounds.left) / bounds.width * 100));
            var y = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100));
            zoomImage.style.transformOrigin = `${x}% ${y}%`;
            zoomImage.classList.toggle('is-zoomed', zoomImage.complete && zoomImage.naturalWidth > 0);
        }, { passive: true });

        link.addEventListener('pointerleave', () => {
            hovering = false;
            if( zoomImage ) zoomImage.classList.remove('is-zoomed');
        });
    });
}

function loadQuickShopProduct(popupModal, handle, focusProduct){
    var popupModalContent = popupModal.querySelector('.popup-modal__content');
    var popupInner = popupModal.querySelector('.popup-modal__inner');
    var labels = popupModal.quickShopLabels;

    if( popupModal.quickShopRequest ){
        popupModal.quickShopRequest.abort();
    }

    var request = new AbortController();
    popupModal.quickShopRequest = request;
    popupModal.quickShopHandle = handle;
    popupModal.classList.add('is-loading');
    popupModalContent.setAttribute('aria-busy', 'true');
    popupModal.querySelectorAll('.quickshop-navigation__button').forEach((button) => button.disabled = true);

    if( !popupModalContent.firstElementChild ){
        var loadingMessage = document.createElement('p');
        loadingMessage.classList.add('quickshop-loading');
        loadingMessage.setAttribute('role', 'status');
        loadingMessage.textContent = labels.loading;
        popupModalContent.append(loadingMessage);
    }

    return fetch(`${window.Shopify.routes.root}products/${handle}?view=quickview`, { signal: request.signal })
        .then((response) => {
            if (!response.ok) {
                throw new Error(response.status);
            }

            return response.text();
        })
        .then((res) => {
            var html = new DOMParser().parseFromString(res, 'text/html').querySelector('.main-product');

            if( !html ){
                throw new Error('Quick Shop product content was not found');
            }

            html.classList.add('quickview-product');
            html.classList.remove('main-product');

            var productInfoButtons = html.querySelectorAll('.product-info-popup__button');
            for( let productInfoButton of productInfoButtons ){
                productInfoButton.setAttribute('target', '_blank');
            }

            popupModalContent.replaceChildren(html);
            setupQuickShopZoom(html);
            popupModalContent.scrollTop = 0;
            popupInner.scrollTop = 0;
            updateQuickShopNavigation(popupModal, handle);

            if (window.Shopify && Shopify.PaymentButton) {
                Shopify.PaymentButton.init();
            }

            if( focusProduct ){
                var productFocusTarget = html.querySelector('.product-summary__title a, select, button, a[href]');
                if( productFocusTarget ){
                    productFocusTarget.focus();
                }
            }
        })
        .catch((error) => {
            if( error.name === 'AbortError' ){
                return;
            }

            var errorMessage = document.createElement('p');
            errorMessage.classList.add('quickshop-error');
            errorMessage.setAttribute('role', 'alert');
            errorMessage.textContent = labels.error;
            popupModalContent.replaceChildren(errorMessage);
            updateQuickShopNavigation(popupModal, handle);
        })
        .finally(() => {
            if( popupModal.quickShopRequest === request ){
                popupModal.quickShopRequest = null;
                popupModal.classList.remove('is-loading');
                popupModalContent.removeAttribute('aria-busy');
            }
        });
}

function loadQuickShopPage(popupModal, url, direction){
    var popupModalContent = popupModal.querySelector('.popup-modal__content');
    var labels = popupModal.quickShopLabels;

    if( popupModal.quickShopRequest ){
        popupModal.quickShopRequest.abort();
    }

    var request = new AbortController();
    popupModal.quickShopRequest = request;
    popupModal.classList.add('is-loading');
    popupModalContent.setAttribute('aria-busy', 'true');
    popupModal.querySelectorAll('.quickshop-navigation__button').forEach((button) => button.disabled = true);

    return fetch(url, { signal: request.signal })
        .then((response) => {
            if( !response.ok ){
                throw new Error(response.status);
            }

            return response.text();
        })
        .then((res) => {
            var products = new DOMParser().parseFromString(res, 'text/html').querySelector('.products');
            var buttons = products ? Array.from(products.querySelectorAll('.product-quickview[data-handle]')) : [];
            var target = direction === 'previous' ? buttons[buttons.length - 1] : buttons[0];

            if( !target ){
                throw new Error('Quick Shop collection page was not found');
            }

            setQuickShopPage(popupModal, target);
            return loadQuickShopProduct(popupModal, target.dataset.handle, false);
        })
        .catch((error) => {
            if( error.name === 'AbortError' ){
                return;
            }

            var errorMessage = document.createElement('p');
            errorMessage.classList.add('quickshop-error');
            errorMessage.setAttribute('role', 'alert');
            errorMessage.textContent = labels.error;
            popupModalContent.replaceChildren(errorMessage);
            updateQuickShopNavigation(popupModal, popupModal.quickShopHandle);
        })
        .finally(() => {
            if( popupModal.quickShopRequest === request ){
                popupModal.quickShopRequest = null;
                popupModal.classList.remove('is-loading');
                popupModalContent.removeAttribute('aria-busy');
            }
        });
}

document.addEventListener('click', (event) => {
    var navigationButton = event.target.closest('[data-quick-shop-direction]');

    if( navigationButton ){
        var navigationModal = navigationButton.closest('.quickshop-modal');
        var navigationHandle = navigationButton.dataset.handle;
        var navigationPageUrl = navigationButton.dataset.pageUrl;

        if( navigationModal && !navigationButton.disabled ){
            navigationModal.focus({ preventScroll: true });
            if( navigationHandle ){
                loadQuickShopProduct(navigationModal, navigationHandle, false);
            }
            else if( navigationPageUrl ){
                loadQuickShopPage(navigationModal, navigationPageUrl, navigationButton.dataset.quickShopDirection);
            }
        }

        return;
    }

    var productQuickview = event.target.closest('.product-quickview');

    if( !productQuickview ){
        return;
    }

    var popupModal = getQuickShopModal(productQuickview);
    setQuickShopPage(popupModal, productQuickview);
    popupModal.returnFocusElement = productQuickview;
    popupModal.quickShopLabels = {
        previous: productQuickview.dataset.quickShopPrevious || 'Previous',
        next: productQuickview.dataset.quickShopNext || 'Next',
        of: productQuickview.dataset.quickShopOf || 'of',
        loading: productQuickview.dataset.quickShopLoading || 'Loading product…',
        error: productQuickview.dataset.quickShopError || 'We could not load this product. Please try again.'
    };

    popupModal.querySelector('.quickshop-navigation__previous').textContent = popupModal.quickShopLabels.previous;
    popupModal.querySelector('.quickshop-navigation__next').textContent = popupModal.quickShopLabels.next;
    popupModal.classList.remove('inactive', 'section-popup');
    popupModal.classList.add('quickview-modal');
    popupModal.querySelector('.popup-modal__close').focus({ preventScroll: true });
    productQuickview.classList.add('loading');

    loadQuickShopProduct(popupModal, productQuickview.dataset.handle, true)
        .finally(() => productQuickview.classList.remove('loading'));
})

// Product swatch hover image
document.addEventListener('mousemove', (e) => {
    if( e.target.classList.contains('product-swatch') ){
        var productSwatch = e.target; 

        var productSwatchVariantId = productSwatch.dataset.variantId

        // console.log("product swatch", productSwatch);
        var productImageElement = productSwatch.closest('.product').querySelector('.product__image');

        var swatchVariantImages = productImageElement.querySelectorAll('.product-swatches-variant-images-variant-image')
        swatchVariantImages.forEach(swatchVariantImage => {
            if(swatchVariantImage.dataset.variantId == productSwatchVariantId){
                swatchVariantImage.classList.add('active')
            }
            else{
                swatchVariantImage.classList.remove('active')
            }
        })
    }
    else{
        var swatchVariantImages = document.querySelectorAll('.product-swatches-variant-images-variant-image')
        swatchVariantImages.forEach(swatchVariantImage => {
            swatchVariantImage.classList.remove('active')
        })
    }
})


// Shoppable Pins 

class ShoppablePins extends HTMLElement {
    constructor(){
        super();


        this.product = this.querySelector('.section-image-pins-list-item-product');

        var pin = this.querySelector('.section-image-pins-list-item-pin');
        
        pin.addEventListener('click', (event) => {
            // var this = pin.parentNode
            // console.log("pin parent", this);
            // console.log("pin clicked", this.classList.contains('active'));
            this.classList.contains('active') ? this.close() : this.open(event)
        })
    
    
        document.addEventListener('click', (event) => {

            if (event.target !== this && !this.contains(event.target)) {
                this.close()
            }
        })
    }


    // open() {
    //     this.product.style.display = 'block';

    //     setTimeout(() => {
    //         this.classList.add('active')
    //     }, 50);
    // }
    // close() {
    //     this.classList.remove('active')

    //     setTimeout(() => {
    //         this.product.style.display = 'none';
    //     }, 300);
    // }

    open(event) {

        this.product.style.display = 'block';

        var panelHeight = this.product.offsetHeight;
        var panelWidth = this.product.offsetWidth;
        var x = event.clientX, 
        y = event.clientY;

        
        if( (window.innerHeight - y) > panelHeight ){
            this.product.classList.add('place-below');
        }
        else if( y > panelHeight ){
            this.product.classList.add('place-above');
        }
        else{
            this.product.classList.add('place-center');
        }


        if( (window.innerHeight - x) > panelWidth ){
            this.product.classList.add('place-right');
        }
        else if( y > panelWidth ){
            this.product.classList.add('place-left');
        }
        else{
            this.product.classList.add('place-center');
        }

        setTimeout(() => {
            this.classList.add('active')
        }, 50);
        // this.classList.add('active');

    }

    close() {
        this.classList.remove('active');


        setTimeout(() => {
            this.product.classList.remove('place-above', 'place-below', 'place-center', 'place-left', 'place-right');
            this.product.style.display = 'none';
        }, 300);
    }

}
customElements.define('shoppable-pin', ShoppablePins)



function AjaxProductUpdate(product, data){

    var cartCountElements = document.querySelectorAll('.cart-count');
    var cartDrawerSelector = '.cart-drawer-inner';

    // Count update
    for(let cart_count of cartCountElements){
        var totalCount = parseInt(data['quantity']);
        
        if(cart_count.textContent){
            totalCount = parseInt(cart_count.textContent) + parseInt(data['quantity'])
        }
        
        cart_count.textContent = totalCount
        // cart_count.textContent = product.item_count
    }

    // Drawer update
    var cartDrawer = product.sections['cart-drawer'];
    var cartDrawerInnerDOM = new DOMParser().parseFromString(cartDrawer, 'text/html').querySelector(cartDrawerSelector);

    var cartDrawerInner = document.querySelector('.cart-drawer-inner');
    if( cartDrawerInner ){
        cartDrawerInner.replaceWith(cartDrawerInnerDOM);
        cartDrawerInnerDOM.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true }));
    }

}


// Product add to cart Ajax
document.body.addEventListener('click', event => {

    let productAddToCartSelector = '.product-add-to-cart';
    let productAddToCart = event.target.closest(productAddToCartSelector);

    if( productAddToCart && !productAddToCart.hasAttribute('disabled') ){
        event.preventDefault();

        let cartDrawerSelector = 'cart-drawer';
        // let addToCartForm = event.target.closest('form[action$="/cart/add"]');
        let addToCartForm = event.target.closest('.product-options-form');

        let productSummary = productAddToCart.closest('.product-summary');
        let productSummaryTitle = productSummary.querySelector('.product-summary__title');
        let productSummaryAction = productSummary.querySelector('.product-summary__action');
        let productQty = productSummary.querySelector('input[name="quantity"]');
        
        let formData = new FormData(addToCartForm);
        let data = Object.fromEntries(formData.entries());

        // data['sections'] = [
        //     cartDrawerSelector
        // ];
        formData.append(
            'sections',
            cartDrawerSelector
        );

        if( (parseInt(data['quantity']) > parseInt(productQty.getAttribute('max'))) && productAddToCart.hasAttribute('disabled') ){

            let productSelect = addToCartForm.querySelector('select');
            
            if( productSummaryAction.firstElementChild.classList.contains('error') ){
                let errorParagraph = productSummaryAction.firstElementChild;
                errorParagraph.innerHTML = productAddToCart.dataset.textQtyError.replace('%qty', productQty.getAttribute('max') + ' ' + productSummaryTitle.innerText + ' - ' + productSelect.options[productSelect.selectedIndex].textContent.trim());
            }
            else{
                let errorParagraph = document.createElement('p');
                errorParagraph.classList.add('error');
                errorParagraph.innerHTML = productAddToCart.dataset.textQtyError.replace('%qty', productQty.getAttribute('max') + ' ' + productSummaryTitle.innerText + ' - ' + productSelect.options[productSelect.selectedIndex].textContent.trim());
                productSummaryAction.prepend( errorParagraph )
            }

            return false;
        }

        // console.log("data", data);

        // Recipient Form 
        var recipientForm = productSummary.querySelector('.recipient-form');
        if( recipientForm ){
            var recipientFormErrors = recipientForm.querySelector('.recipient-form-errors');
            var isRecipientFormEnabled = productSummary.querySelector('.recipient-form-toggle input:checked') ? true : false;
            var recipientFormInputs = recipientForm.querySelectorAll('.recipient-form-fields--field');

            // console.log("checked togggle", isRecipientFormEnabled);

            if( isRecipientFormEnabled ){
                var errors = [];
                recipientFormInputs.forEach(formInput => {
                    // console.log("form input", formInput);
                    if( formInput.classList.contains('required') ) {
                        // console.log("form input", formInput);

                        if( formInput.getAttribute('type') == 'email' ){
                            var pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                            var formInputValue = formInput.value;
                            // console.log( "Email validation", pattern.test(formInputValue) );

                            if( !pattern.test(formInputValue) ){
                                errors.push('Enter a valid email address');

                            }
                        }
                    }
                    if( formInput.getAttribute('type') == 'date' ){
                        // console.log("difference", new Date().toString(), new Date(Date.parse(formInput.value)))
                        
                        var timeDiff = new Date(Date.parse(formInput.value)).getTime() - new Date().getTime();
                        var daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

                        if( daysDiff < 0 || daysDiff > 90 ){
                            errors.push('Enter a valid date (not longer than 90 days from now)');
                        }
                        
                    }
                });
                // console.log("errors", errors);
                if( errors.length > 0 ){
                    var errorElements = errors.map(function(element) {
                        return `<li>${element}</li>`;
                    });

                    recipientFormErrors.innerHTML = errorElements.join("");

                    return false;

                }
            }
        }


        fetch(`${window.Shopify.routes.root}cart/add`, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' },
            // body: JSON.stringify(data)
            body: formData
        })
        .then(response => {
            // console.log("response errors", response.text());
            
            return response.json();
        })
        .then(res => {
            // console.log("res", res);
            if (res.status == 422) {
                if( productSummaryAction.firstElementChild.classList.contains('error') ){
                    let errorParagraph = productSummaryAction.firstElementChild;
                    errorParagraph.innerHTML = res.description;
                }
                else{
                    let errorParagraph = document.createElement('p');
                    errorParagraph.classList.add('error');
                    errorParagraph.innerHTML = res.description;
                    productSummaryAction.prepend( errorParagraph )
                }

                return false;
            }


            AjaxProductUpdate(res, data);

            // Drawer show
            let cartDrawer = document.querySelector('cart-drawer');
            if( cartDrawer ){
                cartDrawer.classList.add('active');
            }

            // Popup (Quickview) hide
            let popupModal = document.querySelector('popup-modal');
            if( popupModal ){
                if( popupModal.classList.contains('quickshop-modal') ){
                    popupModal.remove();
                }
                else{
                    popupModal.classList.add('inactive');
                    popupModal.querySelector('.popup-modal__content').innerHTML = '';
                }
            }
        })
        .catch((error) => {
            console.error(error);
        });


    }

});

class ProductVariantsSelectors extends HTMLElement{
    constructor(){
        super();

        const url = window.location.search;
        const urlParams = new URLSearchParams(url);
        const currentVariant = urlParams.get('variant');


        this.productVariantSelectors = this.querySelectorAll('select');

        this.productVariantSelectors.forEach(variant => { 

            if( currentVariant && currentVariant != '' ){
                const variantId = variant.options[variant.selectedIndex].value;

                if( variantId == currentVariant ){

                    this.onVariantChange(variant);
                }
            }
            
            variant.addEventListener('change', (event) => {
                this.onVariantChange(variant);
            })
        })
        
    }

    onVariantChange = (productVariantSelector) => {

        const variantId = productVariantSelector.options[productVariantSelector.selectedIndex].value;
        const summarySelector = '.product'

        // console.log("variant change triggered", variantId);


        var productAddtocartElement = productVariantSelector.closest(summarySelector).querySelector('.product-add-to-cart');
        var productQtyElement = productVariantSelector.closest(summarySelector).querySelector('.product-inventory-qty');
        var productPriceElement = productVariantSelector.closest(summarySelector).querySelector('.product-price')

        if( variantId == 'none' ){

            productAddtocartHtml = '<span>' + productAddtocartElement.dataset.textUnavailable + '</span>'
            productAddtocartElement.disabled = true

            productAddtocartElement.innerHTML = productAddtocartHtml;
            productQtyElement.innerHTML = '';
            if(productPriceElement){
              productPriceElement.classList.add('hide');
            }
            // productQtyElement.classList.add('hide');

            return false;
        }
        else{
            // productQtyElement.classList.remove('hide');
            if(productPriceElement){
              productPriceElement.classList.remove('hide');
            }
        }

        
        // fetch(`${window.Shopify.routes.root}variants/${variantId}?section_id=product-variant-image`)
        // .then(response => response.text())
        // .then(res => {
        //     console.log("res", res)
        // })
        // .catch(error => {
        //     console.error(error);
        // })


        fetch(`/variants/${variantId}.json`)
        .then(response => response.json())
        .then(res => {
            // console.log("res", res)
            const productVariant = res.product_variant
            
            const comparePriceValue = productVariant.compare_at_price;
            const priceValue = productVariant.price;
            const unitPriceValue = productVariant.unit_price;

            const comparePrice = Shopify.formatMoney(comparePriceValue, moneyFormat);
            const price = Shopify.formatMoney(priceValue, moneyFormat);
            const unitPrice = Shopify.formatMoney(unitPriceValue, moneyFormat);


            var productPriceElement = productVariantSelector.closest(summarySelector).querySelector('.product-price')
            var priceElement = productVariantSelector.closest(summarySelector).querySelector('[data-price]');
            var comparePriceElement = productVariantSelector.closest(summarySelector).querySelector('[data-price-compare]');
            var unitPriceWrapperElement = productVariantSelector.closest(summarySelector).querySelector('.product-price-unit')
            
            var saleBadgeElement = productVariantSelector.closest(summarySelector).querySelector('.product-sale-badge');

            var productPriceText = productPriceElement.dataset.textSale

            // Change price
            priceElement.innerHTML = price;

            if( comparePriceValue ){

                // Add Sale badge if not exist
                if( !saleBadgeElement ){
                    var newSaleBadgeElement = document.createElement('span');
                    newSaleBadgeElement.classList.add('product-sale-badge');
                    newSaleBadgeElement.innerHTML = productPriceText
                    productPriceElement.prepend(newSaleBadgeElement)
                }

                // Change compare price
                comparePriceElement.innerHTML = comparePrice;
            }
            else{
                // Remove sale badge if exist
                if( saleBadgeElement ){
                    saleBadgeElement.remove();
                }

                // Remove compare price
                if( comparePriceElement ){
                    comparePriceElement.innerHTML = '';
                }
            }


            // Change unit price
            if( unitPriceValue ){

                const refValue = productVariant.unit_price_measurement.reference_value
                const refUnit = productVariant.unit_price_measurement.reference_unit

                var unitPriceSelector = 'data-price-unit-price';
                var unitBaseSelector = 'data-price-unit-base';

                var unitPriceElement = productVariantSelector.closest(summarySelector).querySelector('[' + unitPriceSelector + ']');
                var unitBaseElement = productVariantSelector.closest(summarySelector).querySelector('[' + unitBaseSelector + ']');

                // newSaleBadgeElement.innerHTML = productPriceText
                // productPriceElement.prepend(newSaleBadgeElement)

                if( unitPriceWrapperElement ){

                    unitPriceElement.innerHTML = unitPrice

                    // Change unit ref
                    unitBaseElement.innerHTML = ( refValue > 1 ) ? refValue + refUnit : refUnit
                }
                else{
                    var newUnitPriceWrapperElement = document.createElement('span');
                    var newUnitPriceElement = document.createElement('span');
                    var newUnitBaseElement = document.createElement('span');

                    newUnitPriceElement.setAttribute(unitPriceSelector, '')
                    newUnitBaseElement.setAttribute(unitBaseSelector, '')

                    newUnitPriceElement.innerHTML = unitPrice

                    // Change unit ref
                    newUnitBaseElement.innerHTML = ( refValue > 1 ) ? refValue + refUnit : refUnit

                    newUnitPriceWrapperElement.classList.add('product-price-unit');
                    newUnitPriceWrapperElement.append(newUnitPriceElement);
                    newUnitPriceWrapperElement.append('/');
                    newUnitPriceWrapperElement.append(newUnitBaseElement);
                    productPriceElement.append(newUnitPriceWrapperElement)

                }
            }
            else{
                // Remove unit price wrapper
                if( unitPriceWrapperElement ){
                    unitPriceWrapperElement.remove();
                }
            }

        })
        .catch(e => {
            console.error(e);
        });


        // var selectedIndex = productVariantSelector.selectedIndex;
        // var variantId = productVariantSelector[selectedIndex].getAttribute('value');

        var select = productVariantSelector.closest(summarySelector).querySelector('.product-variants-selector > select');
        var productQtyInput = productVariantSelector.closest(summarySelector).querySelector('.product-quantity-picker-input');
        var productQtyElement = productVariantSelector.closest(summarySelector).querySelector('.product-inventory-qty');
        var productAddtocartElement = productVariantSelector.closest(summarySelector).querySelector('.product-add-to-cart');
        var moneyFormat = document.body.dataset.moneyFormat;

        var productStockHtml = '';
        var productAddtocartHtml = '';

        var productStockQty = select[select.selectedIndex].dataset.inventoryQuantity
        var productStockManagement = select[select.selectedIndex].dataset.inventoryManagement
        var productStockPolicy = select[select.selectedIndex].dataset.inventoryPolicy
        var productAvailable = select[select.selectedIndex].dataset.available
        





        if( productQtyInput ){
            if( productStockQty != 0 && productStockManagement != '' ){
                productQtyInput.setAttribute('max', productStockQty );
            }
            else if( productStockManagement == '' ){
                productQtyInput.removeAttribute('max');
            }
        }
        
        if(productQtyElement){
            if( productStockQty != 0 ){
                var lowStockThreshold = productQtyElement.dataset.lowStockThreshold;

                if( lowStockThreshold >= productStockQty ){
                    productStockHtml = '<p class="low">' + productQtyElement.dataset.textLowStock.replace('%s', productStockQty) + '</p>'
                }
                else if (productStockManagement != '' && productStockPolicy != 'continue'){
                    productStockHtml = '<p class="normal">' + productQtyElement.dataset.textInStock.replace('%s', productStockQty) + '</p>'
                }
                else{
                    productStockHtml = '<p class="normal">' + productQtyElement.dataset.textInStockNoTrack + '</p>'
                }

            }
            else if( productStockQty == 0 && productStockManagement == '' ){
                productStockHtml = '<p class="normal">' + productQtyElement.dataset.textInStockNoTrack + '</p>'
            }
            else{
                productStockHtml = '<p class="sold">' + productQtyElement.dataset.textSold.replace('%s', productStockQty) + '</p>'
            }

            productQtyElement.innerHTML = productStockHtml
        }


        // if( productAddtocartHtml ){
            // if( productStockQty != 0 || productStockManagement == '' ){
            if( productAvailable == 'true' ){
                productAddtocartHtml = '<span>' + productAddtocartElement.dataset.textAddToCart + '</span>';
                productAddtocartElement.disabled = false
            }
            else{
                productAddtocartHtml = '<span>' + productAddtocartElement.dataset.textSoldOut + '</span>'
                productAddtocartElement.disabled = true
            }
            // console.log("stock html", productStockHtml, "add to cart html", productAddtocartHtml);

            productAddtocartElement.innerHTML = productAddtocartHtml
        // }



        // Changing image
        var productThumbails = productVariantSelector.closest(summarySelector).querySelectorAll('.product-image-has-variant-ids')

        for (let thumbnail of productThumbails){
            const imageVariantIds = thumbnail.dataset.variantIds
            // console.log("image variant ids", imageVariantIds);
            if( imageVariantIds.includes(variantId) ){
                // console.log("missing")
                thumbnail.dispatchEvent(new Event('click'));
            }
        }

    }
}
customElements.define('product-variants-selector', ProductVariantsSelectors)

// var productVariantSelectors = document.querySelectorAll('.product-variants-selector > select')
// if( productVariantSelectors ){
//     productVariantSelectors.forEach(variant => { 
//         variant.addEventListener('change', (event) => {
//             onVariantChange(variant);
//         })
//     })
// }



// var collectionTitles = document.querySelectorAll('.section-collections-links-collection__title');

// for(var title of collectionTitles){
//     title.addEventListener('mousemove', function(){
//         console.log("title", title.nextElementSibling)
//     })
// }

document.addEventListener("mousemove", function(event){
    if( event.target.classList.contains('collection-title') ){
        var collectionImage = event.target.nextElementSibling;
        if( collectionImage ){
            
            // setTimeout(()=> {
                event.target.nextElementSibling.style.left = event.offsetX + "px";
                event.target.nextElementSibling.style.top = event.offsetY + "px";
            // }, 20)
        }
    } 
});

// Video player controls
var videoPlay = document.querySelectorAll('.video-play');

videoPlay.forEach(button => {
    button.addEventListener('click', function(e){
        var player = button.closest('.video-player');
        var playerVideo = player.querySelector('video');
        var playerIframe = player.querySelector('iframe');

        if( playerVideo ){
            playerVideo.play();
        }

        if( playerIframe ){
            playerIframe.setAttribute('src', playerIframe.getAttribute('src') + '?autoplay=1')
        }

        player.classList.add('playing');

    })
})



// Collapsible row
class CollapsibleRow extends HTMLElement{
    constructor(){
        super();

        this.detectDefaultTab();

        this.querySelector('.collapsible-row__title').addEventListener('click', () => {
            this.onClick();
        })

        
    }

    detectDefaultTab = () => {
        if( this.classList.contains('active_by_default') ){
            var collapsibleContent = this.querySelector('.collapsible-row__content');
            var collapsibleContentHeight = collapsibleContent.offsetHeight;
            collapsibleContent.style.height = collapsibleContentHeight + 'px';
            this.classList.remove('active_by_default');
        }   
    }

    onClick = () => {

        // var productCollapsibleRow = event.target.closest('collapsible-row');
        var productCollapsibleRow = this.closest('collapsible-row');
        var collapsibleContent = productCollapsibleRow.querySelector('.collapsible-row__content');
        var collapsibleContentHeight = collapsibleContent.offsetHeight;

        if( productCollapsibleRow.classList.contains('active') ){
            collapsibleContent.style.removeProperty('height');
            setTimeout(function(){
                productCollapsibleRow.classList.remove('active');
            }, 200)
        }
        else{
            productCollapsibleRow.classList.add('active');
            setTimeout(function(){
                collapsibleContent.style.height = collapsibleContentHeight + 'px';
            }, 10)
        }
    }

}
customElements.define('collapsible-row', CollapsibleRow)



class Countdown extends HTMLElement {
    constructor(){
        super();


        var countdownTimeZone = this.dataset.countdownTimezone
        var countdownEndDate = this.dataset.countdownEnddate

        var currentDate = new Date(); // Create a new Date object with the current date and time

        if( this.dataset.countdownTimezone != '' ){
            var timezoneOffset = this.dataset.countdownTimezone * 60;
            currentDate = new Date(new Date().getTime() + timezoneOffset * 600); // Apply the offset
        }

        // console.log("date", new Date().getTime(), new Date(new Date().getTime()), this.dataset.countdownTimezone, new Date(new Date().getTime() + (timezoneOffset * 6000)));

        this.startdate = currentDate,
        this.enddate = new Date(this.dataset.countdownEnddate);


        // console.log("date", this.startdate, this.enddate);

        if (this.enddate > this.startdate) {
            var countdownExpireMessage = this.querySelector('.countdown-message');
            if(countdownExpireMessage){
                countdownExpireMessage.remove();
            }

            this.updateCountdown();
            var timeinterval = setInterval(this.updateCountdown, 1000);

        }
        else{
            this.querySelector('.countdown-holder').remove();

            if(countdownExpireMessage){
                this.querySelector('.countdown-message').classList.remove('hide');
            }
        }

    }


    getTimeRemaining = () => {

        var currentDate = new Date(); 

        if( this.dataset.countdownTimezone != '' ){
            var timezoneOffset = this.dataset.countdownTimezone * 60;
            currentDate = new Date(new Date().getTime() + timezoneOffset * 600); // Apply the offset
        }

        var t = Date.parse(this.enddate) - Date.parse(currentDate),
            seconds = Math.floor((t / 1000) % 60),
            minutes = Math.floor((t / 1000 / 60) % 60),
            hours = Math.floor((t / (1000 * 60 * 60)) % 24),
            days = Math.floor(t / (1000 * 60 * 60 * 24));

        return {
            'total': t,
            'days': days,
            'hours': hours,
            'minutes': minutes,
            'seconds': seconds
        };
    }
    
    updateCountdown = () => {
        var t = this.getTimeRemaining();

        this.querySelector('.days').innerHTML = t.days;
        this.querySelector('.hours').innerHTML = ('0' + t.hours).slice(-2)
        this.querySelector('.minutes').innerHTML = ('0' + t.minutes).slice(-2)
        this.querySelector('.seconds').innerHTML = ('0' + t.seconds).slice(-2)

        if (t.total <= 0) {
            clearInterval(timeinterval);
        }
    }
        
}
customElements.define('countdown-timer', Countdown);


// document.querySelectorAll('img').forEach(

//   (el) => {
//     // el.wrap('div');
//     var newParentNode = document.createElement('div');
//     var newNode = document.createElement('div');
//     newNode.classList.add('dummy-placeholder');
//     newNode.style.backgroundColor = '#d0d0d0';
//     newNode.style.position = 'absolute';
//     newNode.style.inset = 0;
//     // newParentNode.innerHTML = newNode;
//     newParentNode.appendChild(newNode);
//     newParentNode.style.position = 'relative';
//     newParentNode.style.width = '100%';
//     newParentNode.style.height = '100%';
//     newParentNode.style.aspectRatio = 1;
//     el.replaceWith(newParentNode);
//   }
// );

document.querySelectorAll('.product-option-picker-label-wrapper').forEach(elm => {
    
    elm.addEventListener('click', function(){
        console.log(11111)
        elm.closest('.product-option-picker').classList.toggle('closed')
    })
})

// Header Scroll
let sectionAnnouncementBar = document.querySelector('.section-announcement-bar');
let sectionHeader = document.querySelector('.section-header');
if(sectionAnnouncementBar){
    scrollWithAnnouncementBar()
    window.addEventListener("scroll", function(){
        scrollWithAnnouncementBar()
    })
}else{
    scrollWithoutAnnouncementBar()
    window.addEventListener("scroll", function(){
        scrollWithoutAnnouncementBar()
    })
}

function scrollWithAnnouncementBar(){
    if(window.scrollY > sectionAnnouncementBar.offsetHeight){
        sectionHeader.classList.add('scroll')
    }else{
        sectionHeader.classList.remove('scroll')
    }
}
function scrollWithoutAnnouncementBar(){
    if(window.scrollY > 0){
        sectionHeader.classList.add('scroll')
    }else{
        sectionHeader.classList.remove('scroll')
    }
}

sizeChart()

function sizeChart(){
    document.querySelectorAll('.sc-tab').forEach(tab => {
        tab.addEventListener('click', function(){
            var tabIndex = tab.dataset.index
            document.querySelectorAll('.sc-tab').forEach(t => {
                if(t.dataset.index !== tabIndex){
                    t.classList.remove('active')
                }else{
                    t.classList.add('active')
                }
            })

            // Info
            document.querySelectorAll('.sc-info').forEach(i => {
                i.classList.remove('active')
            })
            document.querySelectorAll('.sc-info')[tabIndex-1].classList.add('active')

            // Tables
            document.querySelectorAll('.sc-tables table').forEach(t => {
                t.classList.remove('active')
                t.classList.add('hidden')
            })
            document.querySelectorAll('.sc-tables table')[tabIndex-1].classList.add('active')
            document.querySelectorAll('.sc-tables table')[tabIndex-1].classList.remove('hidden')
        })
    })

    if(document.querySelector('[data-sc-in]')){
        document.querySelector('[data-sc-in]').addEventListener('click', function(elm){
            if(!document.querySelector('[data-sc-in]').classList.contains('active')){
                document.querySelector('[data-sc-in]').classList.add('active')
                document.querySelector('[data-sc-cm]').classList.remove('active')
                toggleINCM('in','cm')
            }
        })
    }
    if(document.querySelector('[data-sc-cm]')){
        document.querySelector('[data-sc-cm]').addEventListener('click', function(elm){
            if(!document.querySelector('[data-sc-cm]').classList.contains('active')){
                document.querySelector('[data-sc-cm]').classList.add('active')
                document.querySelector('[data-sc-in]').classList.remove('active')
                toggleINCM('cm', 'in')
            }
        })
    }
}

function toggleINCM(from, to){
    // Charts are always entered in inches. "to" is the unit the customer just picked.
    var showCm = (to === 'in');
    var cmButton = document.querySelector('[data-sc-cm]');
    if (cmButton) { showCm = cmButton.classList.contains('active'); }

    document.querySelectorAll('.sc-tables table tr:not(:first-child) td:not(:first-child)').forEach(function(td){
        // Remember the original inch value the first time we touch this cell
        if (td.dataset.scInHtml === undefined) {
            td.dataset.scInHtml = td.innerHTML;
            td.dataset.scInText = td.innerText.trim();
        }

        if (!showCm) {
            td.innerHTML = td.dataset.scInHtml;   // back to the exact original
            return;
        }

        var inches = scParseInches(td.dataset.scInText);
        if (isNaN(inches)) { return; }           // not a number: leave it alone

        var cm = Math.round(inches * 2.54 * 2) / 2;   // nearest 0.5 cm
        td.innerHTML = String(cm);
    });
}

// Reads "35", "20.9", "35 7/8", "16 4/8" or "7/8". Anything else returns NaN.
function scParseInches(str){
    str = String(str).trim();
    var m = str.match(/^(\d+(?:\.\d+)?)(?:\s+(\d+)\/(\d+))?$/);
    if (m) { return parseFloat(m[1]) + (m[2] ? Number(m[2]) / Number(m[3]) : 0); }
    m = str.match(/^(\d+)\/(\d+)$/);
    if (m) { return Number(m[1]) / Number(m[2]); }
    return NaN;
}

function parseInches(str) {
    str = String(str).trim();
    if (str.includes('/')) {                  // "35 7/8" or "7/8"
        const [whole = '0', frac] = str.split(' ');
        const [n, d] = frac.split('/').map(Number);
        return parseInt(whole, 10) + n / d;
    }
    return parseFloat(str);
}

function gcd(a, b) {              // greatest-common-divisor
    while (b) [a, b] = [b, a % b];
    return a;
}
  
function formatMixedFraction(val, denom = 16) {
    const whole = Math.floor(val);
    let num = Math.round((val - whole) * denom);

    if (num === 0) return `${whole}`;         // exact inch
    if (num === denom) return `${whole + 1}`; // rounds up

    const g = gcd(num, denom);
    return `${whole} ${num / g}/${denom / g}`;
}

function convertSize(value, fromUnit, toUnit, opt = {}) {
    const denom     = opt.denom     ?? 16;
    const precision = opt.precision ?? 2;
  
    fromUnit = fromUnit.toLowerCase();
    toUnit   = toUnit.toLowerCase();
  
    if (fromUnit === toUnit) return value;
  
    let inches, cm;
  
    if (fromUnit === 'in') {
      inches = typeof value === 'number' ? value : parseInches(value);
      cm = inches * 2.54;
    } else if (fromUnit === 'cm') {
      cm = parseFloat(value);
      inches = cm / 2.54;
    } else {
      throw new Error('fromUnit must be "in" or "cm"');
    }
  
    if (toUnit === 'cm')   return Number(cm.toFixed(precision));
    if (toUnit === 'in')   return formatMixedFraction(inches, denom);
  
    throw new Error('toUnit must be "in" or "cm"');
  }
